/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * OpenAPI spec version: Latest
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Assessment type.
 */
export type AssessmentType = 'Llars' | 'Llass';

export const AssessmentType = {
    Llars: 'Llars' as AssessmentType,
    Llass: 'Llass' as AssessmentType
};